import { render } from "./PoweredBy.vue?vue&type=template&id=4d43e036&scoped=true"
import script from "./PoweredBy.vue?vue&type=script&lang=js"
export * from "./PoweredBy.vue?vue&type=script&lang=js"

import "./PoweredBy.vue?vue&type=style&index=0&id=4d43e036&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d43e036"]])

export default __exports__